import cx from 'classnames';
import { observer } from 'mobx-react-lite';
import React from 'react';

import { authStore } from 'auth/authStore';
import { getUserInitials } from 'utils';

import styles from '../../styles.module.css';

const MessageAvatar = observer(({ role }) => (
	<div
		className={cx(styles.msgAvatar, {
			[styles.msgAvatarBot]: role === 'assistant',
			[styles.msgAvatarUser]: role === 'user',
		})}
	>
		{role === 'assistant' ? 'AI' : getUserInitials(authStore.account?.name ?? '')}
	</div>
));

export default MessageAvatar;
